import { render } from "./GesSellos.vue?vue&type=template&id=517fd66e&scoped=true"
import script from "./GesSellos.vue?vue&type=script&lang=js"
export * from "./GesSellos.vue?vue&type=script&lang=js"

import "./GesSellos.vue?vue&type=style&index=0&id=517fd66e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-517fd66e"

export default script